import React from 'react';
import { motion } from 'framer-motion';
import { useEffect } from 'react';

const Terms = () => {
    useEffect(() => {
        // Scroll to the top of the page on component load
        window.scrollTo(0, 0);
    }, []);

    return (
        <motion.div
            className="max-w-4xl mx-auto px-6 mt-20 py-10 bg-gray-50 text-zinc-700"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
        >
            <h1 className="text-3xl font-bold text-left text-zinc-900 mb-6">
                TERMS AND CONDITIONS
            </h1>

            <div className="container mx-auto p-6 text-left">
      <h2 className="text-xl font-semibold">GET OFF MY PAVEMENT LTD</h2>

      <h3 className="text-lg font-semibold mt-4">1. INTERPRETATION</h3>
      <p>
        1.1 In these Conditions, the following definitions apply:
      </p>
      <ul className="list-disc pl-6">
        <li><strong>Administration Fee:</strong> The fee payable by the Customer to Get Off My Pavement LTD, as specified in the Order Confirmation.</li>
        <li><strong>Assignment:</strong> Each new task or claim that Get Off My Pavement LTD’s representatives undertake to process on behalf of the Customer.</li>
        <li><strong>Business Day:</strong> A day (other than a Saturday, Sunday, or public holiday) when banks in England are open for business.</li>
        <li><strong>Cancellation Fee:</strong> A fee payable by the Customer to Get Off My Pavement LTD in the event of cancellation, as set out in these Conditions.</li>
        <li><strong>Charges:</strong> The aggregate of all fees and costs payable by the Customer for the supply of the Services in accordance with clause 5.</li>
        <li><strong>Clear Business Day:</strong> A complete Business Day, excluding the day of Order Confirmation and the day the Services are delivered.</li>
        <li><strong>Commencement Date:</strong> The date on which Get Off My Pavement LTD accepts the Customer’s Order.</li>
        <li><strong>Conditions:</strong> These terms and conditions, along with any additional terms specified in the Order Confirmation.</li>
        <li><strong>Contract:</strong> The agreement between Get Off My Pavement LTD and the Customer for the supply of Services in accordance with these Conditions.</li>
        <li><strong>Customer:</strong> The person or entity who purchases Services from Get Off My Pavement LTD.</li>
        <li><strong>Delivery Date:</strong> The date specified by Get Off My Pavement LTD for the completion of the Services.</li>
        <li><strong>Disbursements:</strong> Costs incurred by Get Off My Pavement LTD in delivering the Services.</li>
        <li><strong>Fee:</strong> The price for the Services, excluding Disbursements, as set out in the Order Confirmation.</li>
        <li><strong>Services:</strong> The claim processing and legal enforcement services provided by Get Off My Pavement LTD to address pavement parking issues.</li>
      </ul>
      
      <p>1.2 These Conditions apply to the Contract and supersede any other terms the Customer seeks to impose or incorporate, or which are implied by trade, custom, practice, or course of dealing.</p>
      
      <h3 className="text-lg font-semibold mt-4">2. BASIS OF CONTRACT</h3>
      <p>2.1 The Order constitutes an offer by the Customer to purchase Services from Get Off My Pavement LTD in accordance with these Conditions.</p>
      <p>2.2 The Order shall only be deemed accepted when Get Off My Pavement LTD issues a written or email confirmation of the Order, at which point the Contract shall commence.</p>
      <p>2.3 The Customer acknowledges that the Contract constitutes the entire agreement between the parties.</p>
      <p>2.4 Get Off My Pavement LTD reserves the right to refuse Orders that do not comply with its policies or legal standards.</p>
      
      <h3 className="text-lg font-semibold mt-4">3. SUPPLY OF SERVICES</h3>
      <p>3.1 Get Off My Pavement LTD shall provide the Services to the Customer in accordance with the Order.</p>
      <p>3.2 Get Off My Pavement LTD shall use reasonable efforts to meet any Delivery Date specified, but such dates are estimates only and not guaranteed.</p>
      <p>3.3 Get Off My Pavement LTD may modify the Services as necessary to comply with applicable law or regulations.</p>
      <p>3.4 Get Off My Pavement LTD warrants that the Services will be provided with reasonable care and skill but does not guarantee specific outcomes or results.</p>
      
      <h3 className="text-lg font-semibold mt-4">4. CUSTOMER'S OBLIGATIONS</h3>
      <ul className="list-disc pl-6">
        <li>Ensure all information provided to Get Off My Pavement LTD is accurate and complete.</li>
        <li>Cooperate fully with Get Off My Pavement LTD in all matters relating to the Services.</li>
        <li>Provide any supporting evidence or documentation required by Get Off My Pavement LTD.</li>
        <li>Use the Services only for lawful purposes and in accordance with applicable laws.</li>
      </ul>
      <p>4.2 Get Off My Pavement LTD shall not be liable for delays or failures caused by the Customer’s failure to meet these obligations.</p>
      
      <h3 className="text-lg font-semibold mt-4">5. CHARGES AND PAYMENT</h3>
      <p>5.1 Charges for the Services will be detailed in the Order Confirmation and may include fees for additional services, disbursements, or other costs incurred by Get Off My Pavement LTD.</p>
      <p>5.2 The Customer agrees to pay invoices within 30 days of receipt.</p>
      <p>5.3 In the event of late payment, Get Off My Pavement LTD may charge interest in accordance with the Late Payment of Commercial Debts (Interest) Act 1998.</p>
      <p>5.4 Payments are to be made by BACS or any other method specified by Get Off My Pavement LTD.</p>
      
      <h3 className="text-lg font-semibold mt-4">6. INTELLECTUAL PROPERTY RIGHTS</h3>
      <p>6.1 All intellectual property rights arising from the Services shall remain the property of Get Off My Pavement LTD.</p>
      <p>6.2 The Customer shall not reproduce, distribute, or otherwise use Get Off My Pavement LTD’s materials without prior written consent.</p>
      
      <h3 className="text-lg font-semibold mt-4">7. CONFIDENTIALITY</h3>
      <p>7.1 The Customer agrees to keep all information regarding Get Off My Pavement LTD’s processes, methods, and pricing confidential.</p>
      <p>7.2 This obligation survives termination of the Contract.</p>
      
      <h3 className="text-lg font-semibold mt-4">8. LIMITATION OF LIABILITY</h3>
      <p>8.1 Nothing in these Conditions excludes Get Off My Pavement LTD’s liability for death or personal injury caused by negligence or for fraud.</p>
      <p>8.2 Get Off My Pavement LTD’s total liability to the Customer shall not exceed the value of the Contract.</p>
      <p>8.3 Get Off My Pavement LTD shall not be liable for indirect or consequential losses, including loss of profits.</p>

      <h3 className="text-lg font-semibold mt-4">9. TERMINATION </h3>
      <p>9.1 Get Off My Pavement LTD may terminate the Contract if the Customer fails to pay any amount due or breaches the Conditions. </p>
      <p>9.2 The Customer may terminate the Contract subject to payment of any applicable Cancellation Fee.</p>
      
      <h3 className="text-lg font-semibold mt-4">10. CONSEQUENCES OF TERMINATION </h3>
      <p>10.1 Upon termination, the Customer shall immediately pay all outstanding fees and return any materials provided by Get Off My Pavement LTD. </p>
      <p>10.2 Termination shall not affect accrued rights or obligations. </p>

      <h3 className="text-lg font-semibold mt-4">11. GENERAL</h3>
      <p>11.1 Force Majeure: Get Off My Pavement LTD shall not be liable for delays or failures caused by events beyond its control, including strikes, natural disasters, or government actions.</p>
      <p>11.2 Notices: Any notices required under the Contract shall be delivered in writing to the addresses specified in the Order.  </p>
      <p>11.3 Governing Law: This Contract shall be governed by the laws of England and Wales, and disputes shall be subject to the exclusive jurisdiction of the English courts.</p>

      <h3 className="text-lg font-semibold mt-4">12. ACCEPTANCE OF TERMS </h3>
      <p>By using the Services of Get Off My Pavement LTD, the Customer agrees to these Terms and Conditions.

</p>

    </div>
        </motion.div>
    );
};

export default Terms;
